import { DropdownOption, mapToDropdownOptionArray } from 'components/final-form/dropdownUtils';
import React, { Component } from "react";
import { MessageSourceProps, withMessages } from 'react-message-source';
import { Button, DropdownProps, Form, Grid, Modal, TextArea, TextAreaProps } from 'semantic-ui-react';
import { getAllNonDeletedTexts } from 'services/textServices';
import axios, { CancelTokenSource } from 'axios';
import { noop } from 'utils/functionUtils';
import FormModalContentContainer from 'components/layout/FormModalContentContainer';
import PraxFormGrid from 'components/layout/PraxFormGrid';
import { PxDropdownSc } from 'components/final-form/Select';

interface Props extends MessageSourceProps {
  modalOpen: boolean,
  onCloseModal: () => void,
  onSaveAction: (text: string) => {},
  accompanyingText: string
}

interface State {
  texts: Array<DropdownOption>,
  selectedText?: string,
  accompanyingText: string,
  cancelTokenSource: CancelTokenSource
}

class AccompanyingTextSegment extends Component<Props, State> {

  private mounted: boolean = false;

  constructor(props: Props) {
    super(props);

    const {accompanyingText = ""} = this.props;
    const cancelTokenSource = axios.CancelToken.source();

    this.state = {
      texts: [],
      accompanyingText: accompanyingText,
      cancelTokenSource
    };

    getAllNonDeletedTexts(cancelTokenSource).then(response => {
      this.setState({
        texts: mapToDropdownOptionArray(response, "description", undefined, "text"),
        selectedText: response[0].text
      })
    }).catch(noop);

  }

  componentDidMount(): void {
    this.mounted = true;
  }

  componentDidUpdate({accompanyingText: prevAccompanyingText}: Readonly<Props>, prevState: Readonly<State>, snapshot?: any): void {

    const {accompanyingText} = this.props;

    if (prevAccompanyingText != accompanyingText) {
      this.setState({
        accompanyingText: accompanyingText
      })
    }
  }

  componentWillUnmount(): void {
    this.mounted = false;

    const {cancelTokenSource} = this.state;
    cancelTokenSource.cancel('Operation canceled by user');
  }

  onCloseModal = () => {

    const {onCloseModal} = this.props;

    this.setState({
      accompanyingText: ""
    });

    onCloseModal();
  };

  onTextSelect = (data: DropdownProps) => {
    this.setState({
      selectedText: data.value as string
    })
  };

  onAccompanyingTextChange = (data: TextAreaProps) => {
    this.setState({
      accompanyingText: data.value as string
    })
  };

  onAddText = () => {

    const {accompanyingText, selectedText} = this.state;

    let text = "";

    if (accompanyingText && accompanyingText !== "") {
      text = accompanyingText + "\n" + selectedText;
    } else if (accompanyingText === "" && selectedText) {
      text = selectedText;
    }

    this.setState({
      accompanyingText: text
    })
  };

  onCancelText = () => {

    const {accompanyingText, onCloseModal} = this.props;

    this.setState({
      accompanyingText: accompanyingText
    });

    onCloseModal();
  };

  render(): React.ReactNode {

    const {modalOpen, onCloseModal, getMessage, onSaveAction} = this.props;
    const {texts, accompanyingText} = this.state;

    return (
        <Modal
            open={modalOpen}
            onClose={onCloseModal}
            closeOnDimmerClick={false}
        >
          <Modal.Header>{getMessage("accompanyingText.text")}</Modal.Header>
          <FormModalContentContainer>
            <PraxFormGrid>
              <Grid.Row>
                <Grid.Column width={3}
                             verticalAlign="middle">{getMessage("accompanyingText.preDefinedText")}: </Grid.Column>
                <Grid.Column width={10}>
                  <PxDropdownSc
                      placeholder={getMessage("accompanyingText.preDefinedText")}
                      fluid
                      search
                      selection
                      options={texts}
                      onChange={(e: any, data: any) => this.onTextSelect(data)}
                  />
                </Grid.Column>
                <Grid.Column verticalAlign="middle">
                  <Button primary compact onClick={this.onAddText}>{getMessage("button.add")}</Button>
                </Grid.Column>
              </Grid.Row>
              <Grid.Row>
                <Grid.Column>
                  <Form>
                    <TextArea
                        placeholder={getMessage("accompanyingText")}
                        value={accompanyingText}
                        onChange={(e, data) => this.onAccompanyingTextChange(data)}
                        style={{minHeight: "300px", maxHeight: "300px"}}
                    />
                  </Form>
                </Grid.Column>
              </Grid.Row>
            </PraxFormGrid>
          </FormModalContentContainer>
          <Modal.Actions style={{textAlign: "left"}}>
            <Button compact primary onClick={() => onSaveAction(accompanyingText)}>{getMessage("button.save")}</Button>
            <Button compact onClick={this.onCancelText}>{getMessage("button.cancel")}</Button>
          </Modal.Actions>
        </Modal>
    );
  }
}

export default withMessages(AccompanyingTextSegment);
